import { Routes } from '@angular/router';
import { TestErrorsComponent } from '../Components/Global/errors/test-errors/test-errors.component';
import { NotFoundComponent } from '../Components/Global/errors/not-found/not-found.component';
import { ServerErrorComponent } from '../Components/Global/errors/server-error/server-error.component';
import { BodyContentItemComponent } from '../Components/Home/Body/body.component';
import { CareersComponent } from '../Components/careers/careers.component';
import { AboutComponent } from '../Components/about/about.component';
import { ContactComponent } from '../Components/contact/contact.component';
import { BugFixLogComponent } from '../Components/bug-fix-log/bug-fix-log.component';
import { FaqComponent } from '../Components/faq/faq.component';
import { AdminLayoutComponent } from '../feature/admin/layout/admin-layout.component'; // (To be removed later)
import { DashboardComponent } from '../feature/admin/content/dashboard/dashboard.component';
import { JobPostComponent } from '../feature/admin/content/job-post/job-post.component';
import { BugReportingComponent } from '../feature/admin/content/bug-reporting/bug-reporting.component';
import { UsersComponent } from '../feature/admin/content/users/users.component';
import { NewsletterComponent } from '../feature/admin/content/newsletter/newsletter.component';
import { AppliedjobComponent } from '../feature/admin/content/applied-jobs/appliedjobs.component';
import { AppManagementComponent } from '../feature/admin/content/app-management/app-management.component';
import { LoginComponent } from '../account/login/login.component';
import { RegisterComponent } from '../account/Register/register.component';
import { ForgotComponent } from '../account/Forgot/forgot.component';
import { UserDetailsComponent } from '../account/user-details/user-details.component';
import { adminGuard, userGuard } from '../Utils/_guards/auth.guard';
import { JoinAppWaitlistComponent } from '../feature/admin/content/join-app-waitlist/join-app-waitlist.component';
import { LayoutComponent } from '../feature/user/layout/user-layout.component';
import { DashboardComponent as UserDashboardComponent } from '../feature/user/content/dashboard/dashboard.component';
import { MarketingComponent } from '../feature/user/content/marketing/marketing.component';
import { BrandImagesComponent } from '../feature/user/content/brand-images/brand-images.component';
import { TwoFaComponent } from '../feature/user/content/two-fa/two-fa.component';
import { AccountsComponent } from '../feature/user/content/accounts/accounts.component';
import { KycComponent } from '../feature/user/content/kyc/kyc.component';
import { ContactResponsesComponent } from '../feature/user/content/contact-responses/contact-responses.component';
import { ReportedBugComponent } from '../feature/user/content/reported-bug/reported-bug.component';
import { RequestFeaturesComponent } from '../feature/user/content/request-features/request-features.component';
import { CareerSubmissionComponent } from '../feature/user/content/career-submission/career-submission.component';
import { AffiliateComponent } from '../feature/user/content/affiliate/affiliate.component';
import { BillingComponent } from '../feature/user/content/billing/billing.component';
import { PartnerComponent } from '../feature/user/content/partner/partner.component';
import { NotificationsComponent } from '../feature/user/content/notifications/notifications.component';
import { BodyLayoutComponent } from '../Components/Layout/2.Body/body-layout.component';
import { ResetPasswordComponent } from '../account/RestPassword/reset-password.component';
import { LoggerComponent } from '../feature/admin/content/logger/logger.component';
import { PrivacyPolicyComponent } from '../Components/privacy-policy/privacy-policy.component';
import { TermsOfServicesComponent } from '../Components/terms-of-services/terms-of-services.component';

export const routes: Routes = [
  // Public site
  {
    path: '',
    component: BodyLayoutComponent,
    children: [
      { path: '', pathMatch: "full", component: BodyContentItemComponent },
      { path: 'careers', component: CareersComponent },
      { path: 'about', component: AboutComponent },
      { path: 'contact', component: ContactComponent },
      { path: 'bug-logs', component: BugFixLogComponent },
      { path: 'faq', component: FaqComponent }
    ],
  },
  // Public auth pages
  {
    path: 'auth',
    children: [
      { path: 'login', component: LoginComponent },
      { path: 'forgot', component: ForgotComponent },
      { path: "reset-password", component: ResetPasswordComponent },
      { path: 'register', component: RegisterComponent },
      { path: 'email-verification', loadComponent: () => import('../account/email-verification/email-verification.component').then(m => m.EmailVerificationComponent) },
      { path: 'phone-verification', loadComponent: () => import('../account/phone-verification/phone-verification.component').then(m => m.PhoneVerificationComponent) },
      { path: 'user-details', component: UserDetailsComponent },
    ],
  },
  // Admin (protected)
  {
    path: 'admin',
    component: LayoutComponent,
    canActivate: [adminGuard],
    children: [
      { path: '', pathMatch: "full", component: DashboardComponent },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'app-management', component: AppManagementComponent },
      { path: 'job-post', component: JobPostComponent },
      { path: 'bug-reporting', component: BugReportingComponent },
      { path: 'users', component: UsersComponent },
      { path: 'newsletters', component: NewsletterComponent },
      { path: 'applied-job', component: AppliedjobComponent },
      { path: 'app-waitlist', component: JoinAppWaitlistComponent },
      { path: 'logs', component: LoggerComponent }
    ],
  },
  // User (protected)
  {
    path: 'user',
    component: LayoutComponent,
    canActivate: [userGuard],
    children: [
      { path: '', pathMatch: "full", component: UserDashboardComponent },
      { path: 'dashboard', component: UserDashboardComponent },
      { path: 'marketing', component: MarketingComponent },
      { path: 'brand-images', component: BrandImagesComponent },
      { path: 'two-fa', component: TwoFaComponent },
      { path: 'accounts', component: AccountsComponent },
      { path: 'kyc', component: KycComponent },
      { path: 'contact-responses', component: ContactResponsesComponent },
      { path: 'reported-bug', component: ReportedBugComponent },
      { path: 'request-features', component: RequestFeaturesComponent },
      { path: 'career-submission', component: CareerSubmissionComponent },
      { path: 'affiliate', component: AffiliateComponent },
      { path: 'billing', component: BillingComponent },
      { path: 'partner', component: PartnerComponent },
      { path: 'notifications', component: NotificationsComponent },
    ],
  },
  // Policies
  { path: "privacy-policy", component: PrivacyPolicyComponent },
  { path: "terms-of-services", component: TermsOfServicesComponent },
  // { path: "cookie-policy", component: CookiePoliciesComponent },
  // { path: "safety-policy", component: SafetyPolicyComponent },
  // Optional error routes
  { path: 'errors/test', component: TestErrorsComponent },
  { path: 'errors/500', component: ServerErrorComponent },
  { path: 'errors/404', component: NotFoundComponent },
  { path: '**', redirectTo: '' },
];
